import { Injectable } from "@angular/core";
import { BaseApi } from "./baseService";
import { BaseResponse } from "../objects/common/baseResponse";
import { Order } from "../objects/orders/order";
import {Http, RequestOptions, URLSearchParams} from "@angular/http";
import { OrderSearchRequest } from "../objects/requests/orderSearchRequest";
import { SearchResponse } from "../objects/responses/searchResponse";
import { PaymentResponse } from "../objects/payment/paymentResponse";
import { OrderBy, Query } from "ngx-odata-v4";
import { Cookie } from "ng2-cookies/ng2-cookies";
import {ActivatedRoute} from "@angular/router";
import {ConfigService} from "./configService";

/**
 * Created by alex.y on 8/9/2017.
 */
@Injectable()
export class OrderService extends BaseApi {

    constructor(protected http: Http,
                protected configService: ConfigService,
                private activatedRoute: ActivatedRoute) {
        super(http, configService);
    }
    public search(request: OrderSearchRequest): Promise<SearchResponse<Order>> {
        let params = new URLSearchParams();

        params.append('top', request.Top.toString());
        params.append('skip', request.Skip.toString());
        params.append('orderBy', request.OrderBy.PropertyName);
        params.append('orderByDir', request.OrderBy.OrderBy.toString());
        params.append('query', encodeURIComponent(request.Query.toString()));

        return this.get<SearchResponse<Order>>(new RequestOptions({
            url: `order/search`,
            search: params
        })).then(r => r.Data);
    }

    public modify(order: Order): Promise<BaseResponse<Order>> {
        return this.post(new RequestOptions({
            url: `order`,
            body: order
        }))
    }

    public create(order: Order, viewType: string): Promise<BaseResponse<Order>> {
        return this.post(new RequestOptions({
            url: `order?viewType=${viewType}`,
            body: order
        }));
    }

    public publicCreate(order: Order, marketingUrl: string, viewType: string): Promise<BaseResponse<Order>> {

        let googleTrackingId = this.activatedRoute.snapshot.queryParams["gclid"];
        let utm_source = this.activatedRoute.snapshot.queryParams["utm_source"];
        let utm_medium = this.activatedRoute.snapshot.queryParams["utm_medium"];
        let utm_campaign = this.activatedRoute.snapshot.queryParams["utm_campaign"];
        let utm_term = this.activatedRoute.snapshot.queryParams["utm_term"];
        let utm_content = this.activatedRoute.snapshot.queryParams["utm_content"];

        if(String.isNullOrEmpty(googleTrackingId)){ // fallback 1
            const cookieNames : Array<string> = Cookie.getAll();

            for(let cookieName in cookieNames){
                if(cookieName.includes("gac_")){
                    let cookie = Cookie.get(cookieName);

                    if(cookie){
                        let sp = cookie.split('.');

                        if(sp.length > 2){
                            googleTrackingId = sp[2];
                        }
                        else {
                            googleTrackingId = cookie;
                        }
                    }
                }
            }
        }

        if(String.isNullOrEmpty(googleTrackingId)){ // fallback 2
            const cookieValue = Cookie.get('__utmz');

            if (cookieValue){
                const parts = cookieValue.split("|");
                const nameAndValue = parts.find(part => part.includes('utmgclid'));
                if(nameAndValue){
                    googleTrackingId = nameAndValue.split("=")[1];
                }
            }
        }

        return this.post(new RequestOptions({
            url: `order?marketingUrl=${marketingUrl}&googleTrackingId=${googleTrackingId}&viewType=${viewType}&utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_term=${utm_term}&utm_content=${utm_content}`,
            body: order
        }));
    }

    public update(order: Order): Promise<BaseResponse<Order>> {
        return this.put(new RequestOptions({
            url: `order`,
            body: order
        }));
    }

    public getById(id: number): Promise<BaseResponse<Order>> {
        return this.get(new RequestOptions({
            url: `order/${id}`,
        }));
    }

    public getEmailOrder(id: number, email: string): Promise<BaseResponse<Order>> {
        return this.post(new RequestOptions({
            url: `order/ccrequestemail`,
            body : {orderId: id, email: email}
        }));
    }


    public createInvoice(orderId: number): Promise<BaseResponse<PaymentResponse>> {
        return this.post(new RequestOptions({
            url: `order/${orderId}/invoice`
        }));
    }

    public sendInvoice(orderId: number, invoiceId: string): Promise<BaseResponse<PaymentResponse>> {
        return this.post(new RequestOptions({
            url: `order/${orderId}/invoice/${invoiceId}/send`
        }))
    }
}



// WEBPACK FOOTER //
// ./app/services/orderService.ts